import styled from "styled-components";
import BannerGoMidiaBH from '../../../../assets/images/landingPage/cor20correta-1920x1533.png';

interface isActive {
    active?: boolean;
}

export const BannerContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
 @media only screen and (max-width: 1000px) {
    height: 70vh;
  }
`;

export const BannerImage = styled.img<{ parallax: number }>`
  width: 100%;
  height: 100vh;
  object-fit: cover;

  transform: translate3d(0, ${({ parallax }) => parallax * 1.0}px, 0);
  will-change: transform;
  transform-style: preserve-3d;
  @media only screen and (max-width: 1000px) {
    height: 70vh;
    object-fit: contain;
  }
  .jarallax-img {
    object-fit: contain;
  }
`;


export const OrcamentoButton = styled.a`
  position: absolute;
  bottom: 10%;
  left: 20%;
  transform: translateX(-50%);
  background: var(--orange);
  padding: 14px 28px;
  border-radius: 100px;
  color: #fff;
  padding: 1rem 3rem;
  text-decoration: none;
  z-index: 3;
    @media only screen and (max-width: 1000px) {
      left: 30%;
    }

  &:hover {
    opacity: 0.9;
  }
`;